import "./styles.scss";

import React, { useEffect, useRef } from "react";
import { Gradient } from "./mini-gl";

const AnimatedGradient = ({ id, options }) => {
  const gradient = useRef(null);
  const optionsClone = useRef(options);
  const isInit = useRef(false);

  useEffect(() => {
    if (id && !isInit.current) {
      isInit.current = true;

      gradient.current = new Gradient(optionsClone.current);
      gradient.current.initGradient(`#${id}`);
    }

    return () => {
      if (isInit.current) {
        gradient.current.destroy();
      }
    };
  }, [id]);

  if (!id) return null;

  return (
    <div className="animated-gradient">
      <canvas id={id} />
    </div>
  );
};

export default AnimatedGradient;
